import { motion } from "framer-motion";

export const withMotion = (Component: any) => (props: any) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ height: "100%", overflow: "hidden" }}
      variants={{
        initial: { opacity: 0 },
        animate: { opacity: 1, transition: { duration: 0.5 } },
        exit: { opacity: 0, transition: { duration: 0.5 } },
      }}
    >
      <Component {...props} />
    </motion.div>
  );
};
